export const getSettingsPages = (showMarketReport) => {
	const pages = [
		{
			title: 'Manage plan',
			pathname: `/plan-details`,
			activeMatches: ['/manage-subscription'],
			showInArchive: false,
			showInStateZero: true,
		},
		{
			title: 'Accessibility',
			pathname: '/accessibility-settings',
			activeMatches: [],
			archived: false,
			showInStateZero: true,
		},
		{
			title: 'Data sharing',
			pathname: '/data-sharing',
			activeMatches: [],
			archived: false,
			showInStateZero: true,
			// Below onClick captures MixPanel for data Sharing
			// onClick: trackSettingsMenuDataSharingClick,
		},
	];

	return showMarketReport
		? [
				...pages,
				{
					title: 'Market insights report',
					pathname: `/market-insights-report`,
					activeMatches: [],
					showInArchive: false,
					showInStateZero: true,
				},
		  ]
		: pages;
};
